import { Form, Modal } from "react-bootstrap";
import Select from 'react-select';
import { organisationSignal } from "../../../signal/organisationSignal";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { userSignal } from "../../../signal/userSignal";
import { toast } from "react-toastify";
import axios from "axios";
import { DEV_SERVER } from "../../../constants/urls";
import { allUsersSignal } from "../../../signal/allUsersSignal";


export default function EditTripModal(props) {

    const [trip, setTrip] = useState(props.trip)
    const [modeOfTransports, setModeOfTransports] = useState(null)
    const [dailyAllowanceRules, setDailyAllowanceRules] = useState(null)

    const updateTripMutation = useMutation((body) => {
        let resp = axios.post(`${DEV_SERVER}/trip/v2/edit-trip`, body.body, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp
    }, {
        onSuccess: (data) => {
            data = data.data;
            if (data.status) {
                toast.success(data.message);
                props?.refetchTrip()
                props?.close()
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const updateTrip = () => {

        let body = {
            body: {
                trip: trip
            }
        }

        updateTripMutation.mutate(body)
    }

    useEffect(() => {
        setTrip(props.trip)
        if (allUsersSignal?.value && allUsersSignal?.value[props?.trip?.userId] && allUsersSignal?.value[props?.trip?.userId]?.ruleType === "custom") {
            let _modeOfTransports = allUsersSignal?.value[props?.trip?.userId]?.modeOfTransports
            let _dailyAllowanceRules = allUsersSignal?.value[props?.trip?.userId]?.dailyAllowanceRules
            setModeOfTransports(_modeOfTransports)
            setDailyAllowanceRules(_dailyAllowanceRules)
        } else if (organisationSignal?.value) {
            let _modeOfTransports = organisationSignal?.value?.modeOfTransports
            let _dailyAllowanceRules = organisationSignal?.value?.dailyAllowanceRules
            setModeOfTransports(_modeOfTransports)
            setDailyAllowanceRules(_dailyAllowanceRules)
        }
    }, [props?.trip])

    return <Modal show={props.show} onHide={() => props.close()}>
        <Modal.Header closeButton>
            <Modal.Title>Edit Trip</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="d-flex flex-column" style={{rowGap:"1rem"}}>
                <Form.Group className="w-100" controlId="formBasicStartKM">
                    <Form.Label>StartKM</Form.Label>
                    <Form.Control value={trip?.startKM} onChange={(e) => {
                        setTrip({ ...trip, startKM: parseFloat(e.target.value) })
                    }} type="number" placeholder="Enter StartKM" />
                </Form.Group>

                <Form.Group className="w-100" controlId="formBasicEndKM">
                    <Form.Label>EndKM</Form.Label>
                    <Form.Control value={trip?.endKM} onChange={(e) => {
                        setTrip({ ...trip, endKM: parseFloat(e.target.value) })
                    }} type="number" placeholder="Enter EndKM" />
                </Form.Group>

                {modeOfTransports && <Form.Group className="w-100" controlId="formBasicModeOfTransport">
                    <Form.Label>Mode Of Transport</Form.Label>
                    <Select
                        as="select"
                        value={{ label: trip?.modeOfTransport, value: trip?.modeOfTransport }}
                        onChange={(e) => {
                            setTrip({ ...trip, modeOfTransport: e?.value })
                        }}
                        options={Object.entries(modeOfTransports).map(([key, value]) => {
                            return (
                                {
                                    label: value?.name,
                                    value: value?.name
                                }
                            )
                        })}
                        isSearchable
                        isClearable
                    />
                </Form.Group>}

                {dailyAllowanceRules && <Form.Group className="w-100" controlId="formBasicDailyAllowance">
                    <Form.Label>Daily Allowance</Form.Label>
                    <Select
                        as="select"
                        value={{ label: trip?.dailyAllowance, value: trip?.dailyAllowance }}
                        onChange={(e) => {
                            setTrip({ ...trip, dailyAllowance: e?.value })
                        }}
                        options={Object.entries(dailyAllowanceRules).map(([key, value]) => {
                            return (
                                {
                                    label: value?.name,
                                    value: value?.name
                                }
                            )
                        })}
                        isSearchable
                        isClearable
                    />
                </Form.Group>}
            </div>
        </Modal.Body>

        <Modal.Footer>
            <button onClick={() => props.close()} disabled={updateTripMutation.isLoading} className="btn btn-secondary">Close</button>
            <button onClick={() => updateTrip()} disabled={updateTripMutation.isLoading} className="btn btn-primary">{updateTripMutation.isLoading ? "Saving..." : "Update Trip"}</button>
        </Modal.Footer>

    </Modal>
}